import { Layout } from 'antd';
import React from 'react';
import styled from 'styled-components';
import AppointmentLayout from '../../Layout';
import AppointmentDetail, { appointmentDetailRef } from '../TableView/Body/Modal/AppointmentDetail';
import BlockHours from '../TableView/Body/Modal/BlockHours';
import BreakTime from '../TableView/Body/Modal/BreakTime';
import MultipleAptDetailV2 from '../TableView/Body/Modal/MultipleAptDetailV2';
import NewAppointmentVersionV2, { newAppointmentVersionV2Ref } from '../TableView/Body/Modal/NewAppointmentV2/v2';
import QuickBooking, { quickBookingRef } from '../TableView/Body/Modal/QuickBooking';
import AppointmentFilterV2 from './Filter';
import AppointmentCalendarHeaderV2 from './Header';
import QuickBookingV2, { quickBookingV2Ref } from '../TableView/Body/Modal/QuickBookingV2';
import AppointmentDetailV3, { aptDetailV3Ref } from '../TableView/Body/Modal/AppointmentDetailV3';

type IAppointmentCalendarProps = any;
const AppointmentCalendarV2: React.FC<IAppointmentCalendarProps> = () => {
  return (
    <AppointmentCalendarStyled>
      <AppointmentCalendarHeaderV2 />
      <AppointmentFilterV2 />
      <AppointmentLayout v2 />
      <NewAppointmentVersionV2 ref={newAppointmentVersionV2Ref} />
      <BlockHours v2 />
      <BreakTime v2 />
      <QuickBooking ref={quickBookingRef} />
      <QuickBookingV2 ref={quickBookingV2Ref} />
      <MultipleAptDetailV2 />
      <AppointmentDetail v2 ref={appointmentDetailRef} />
      <AppointmentDetailV3 ref={aptDetailV3Ref} />
    </AppointmentCalendarStyled>
  );
};

export default AppointmentCalendarV2;
type AppointmentCalendarStyledProps = {}
const AppointmentCalendarStyled = styled(Layout.Content) <AppointmentCalendarStyledProps>`
  width: 100%;
  height: 100%;
  padding: 0;
  padding-top: 0;
  padding-bottom: 5px;
  display: flex;
  flex-direction: column;
`;
